import localforage from 'localforage';
import packageJson from '../../package.json';

let clientDB;

class ClientDB {
  static get CurrentVersion() {
    return packageJson.dbVersion;
  }

  static get Instance() {
    if (!clientDB)
      clientDB = localforage.createInstance({
        name: `EWANO-PWA-V${this.CurrentVersion}`,
        driver: localforage.LOCALSTORAGE,
      });
    return clientDB;
  }
}

export default ClientDB;
